<template>
  <div class="set-warn">
    <div class="nav">
      <div class="nav-left">
        <div class="parallelogram-btn-left" style="margin-right: 0.5vw" @click="backPath">
          <div class="icon-font">&#xe612;</div>
          <div>返回</div>
        </div>
        <div class="parallelogram-btn-left" style="margin-right: 0.5vw"></div>
        <div class="parallelogram-btn-left" style="margin-right: 0.5vw"></div>
        <div class="parallelogram-btn-left" style="margin-right: 0.5vw"></div>
        <div class="parallelogram-btn-left" style="margin-right: 0.5vw"></div>
        <div class="parallelogram-btn-left"></div>
      </div>
      <div class="nav-center">预警值设置</div>
      <div class="nav-right">
        <div class="parallelogram-btn-right" style="margin-right: 0.5vw"></div>
        <div class="parallelogram-btn-right" style="margin-right: 0.5vw"></div>
        <div class="parallelogram-btn-right" style="margin-right: 0.5vw"></div>
        <div class="parallelogram-btn-right" style="margin-right: 0.5vw"></div>
        <div class="parallelogram-btn-right" style="margin-right: 0.5vw"></div>
        <div class="parallelogram-btn-right" @click="handleData">
          <div class="icon-font">&#xec11;</div>
          <div>编辑</div>
        </div>
      </div>
    </div>
    <div class="set-warn-content">
      <div class="warn-wrapper">
        <div class="warn-wrapper-title">
          <div class="tab-item" v-for="(data,index) in title" :key="index"
               :class="{'warn-wrapper-item-active': data.sign === '1'}" @click="changeData(data.value)">{{data.item}}
          </div>
        </div>
        <div class="warn-wrapper-content">
          <div class="warn-wrapper-content-box">
            <div class="input-contain" v-if="inputValue.phases !== '05'">
              <div class="input-title" style="padding-left: 0.75vw">O₂浓度上限：</div>
              <div class="input-suffix-wrapper">
                <input v-model="inputValue.oxygenUpper" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
            <div class="input-contain" v-if="inputValue.phases !== '05'">
              <div class="input-title">包芯温度上限：</div>
              <div class="input-suffix-wrapper">
                <input v-model="inputValue.tempCoreChipUpper" placeholder=""/>
                <div class="input-suffix">（℃）</div>
              </div>
            </div>
            <div class="input-contain" v-if="inputValue.phases !== '05'">
              <div class="input-title">垛内温度上限：</div>
              <div class="input-suffix-wrapper">
                <input v-model="inputValue.stackTempUpper" placeholder=""/>
                <div class="input-suffix">（℃）</div>
              </div>
            </div>
            <div class="input-contain" v-if="inputValue.phases === '05'">
              <div class="input-title">仓库温度上限：</div>
              <div class="input-suffix-wrapper">
                <input v-model="inputValue.warehouseTempUpper" placeholder=""/>
                <div class="input-suffix">（℃）</div>
              </div>
            </div>
          </div>
          <div class="warn-wrapper-content-box">
            <div class="input-contain" v-if="inputValue.phases !== '05'">
              <div class="input-title" style="padding-left: 0.75vw">O₂浓度下限：</div>
              <div class="input-suffix-wrapper">
                <input v-model="inputValue.oxygenLower" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
            <div class="input-contain" v-if="inputValue.phases !== '05'">
              <div class="input-title">包芯温度下限：</div>
              <div class="input-suffix-wrapper">
                <input v-model="inputValue.tempCoreChipLower" placeholder=""/>
                <div class="input-suffix">（℃）</div>
              </div>
            </div>
            <div class="input-contain" v-if="inputValue.phases !== '05'">
              <div class="input-title">垛内温度下限：</div>
              <div class="input-suffix-wrapper">
                <input v-model="inputValue.stackTempLower" placeholder=""/>
                <div class="input-suffix">（℃）</div>
              </div>
            </div>
            <div class="input-contain" v-if="inputValue.phases === '05'">
              <div class="input-title">仓库温度下限：</div>
              <div class="input-suffix-wrapper">
                <input v-model="inputValue.warehouseTempLower" placeholder=""/>
                <div class="input-suffix">（℃）</div>
              </div>
            </div>
          </div>
          <div class="warn-wrapper-content-box">
            <div class="input-contain" v-if="inputValue.phases !== '05'">
              <div class="input-title">包芯水分上限：</div>
              <div class="input-suffix-wrapper">
                <input v-model="inputValue.wetCoreChipUpper" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
            <div class="input-contain" v-if="inputValue.phases !== '05'">
              <div class="input-title" style="padding-left: 0.2vw">CO₂浓度上限：</div>
              <div class="input-suffix-wrapper">
                <input v-model="inputValue.concentrationCo2Upper" placeholder=""/>
                <div class="input-suffix">（PPM）</div>
              </div>
            </div>
            <div class="input-contain" v-if="inputValue.phases !== '05'">
              <div class="input-title">垛内湿度上限：</div>
              <div class="input-suffix-wrapper">
                <input v-model="inputValue.stackMoistureUpper" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
            <div class="input-contain" v-if="inputValue.phases === '05'">
              <div class="input-title">仓库湿度上限：</div>
              <div class="input-suffix-wrapper">
                <input v-model="inputValue.warehouseMoistureUpper" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
          </div>
          <div class="warn-wrapper-content-box">
            <div class="input-contain" v-if="inputValue.phases !== '05'">
              <div class="input-title">包芯水分下限：</div>
              <div class="input-suffix-wrapper">
                <input v-model="inputValue.wetCoreChipLower" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
            <div class="input-contain" v-if="inputValue.phases !== '05'">
              <div class="input-title" style="padding-left: 0.15vw">CO₂浓度下限：</div>
              <div class="input-suffix-wrapper">
                <input v-model="inputValue.concentrationCo2Lower" placeholder=""/>
                <div class="input-suffix">（PPM）</div>
              </div>
            </div>
            <div class="input-contain" v-if="inputValue.phases !== '05'">
              <div class="input-title">垛内湿度下限：</div>
              <div class="input-suffix-wrapper">
                <input v-model="inputValue.stackMoistureLower" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
            <div class="input-contain" v-if="inputValue.phases === '05'">
              <div class="input-title">仓库湿度下限：</div>
              <div class="input-suffix-wrapper">
                <input v-model="inputValue.warehouseMoistureLower" placeholder=""/>
                <div class="input-suffix">（%）</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {queryAlarm, setAlarm} from '../../../api/maintain'
export default {
  name: 'SetWarn',
  data () {
    return {
      title: [
        {item: '自然醇化阶段', value: '01', sign: '1'},
        {item: '防霉杀虫阶段', value: '02', sign: '0'},
        {item: '气调醇化阶段', value: '03', sign: '0'},
        {item: '气调保质阶段', value: '04', sign: '0'},
        {item: '仓间预警值', value: '05', sign: '0'}
      ],
      inputValue: {
        phases: '',
        concentrationCo2Lower: '',
        concentrationCo2Upper: '',
        oxygenLower: '',
        oxygenUpper: '',
        stackMoistureLower: '',
        stackMoistureUpper: '',
        stackTempLower: '',
        stackTempUpper: '',
        tempCoreChipLower: '',
        tempCoreChipUpper: '',
        wetCoreChipLower: '',
        wetCoreChipUpper: '',
        warehouseMoistureLower: '',
        warehouseMoistureUpper: '',
        warehouseTempLower: '',
        warehouseTempUpper: ''
      }
    }
  },
  created () {
    let value = this.$route.query.value
    if (isNaN(value)) {
      value = '01'
    }
    this.inputValue.phases = value
    this.title.map((data) => {
      data.sign = '0'
      console.log(data.value === value)
      if (data.value === value) {
        data.sign = '1'
      }
    })
    this.getAlert()
  },
  watch: {
    '$route' () {
      let value = this.$route.query.value
      if (isNaN(value)) {
        value = '01'
      }
      this.title.map((data) => {
        data.sign = '0'
        if (data.value === value) {
          data.sign = '1'
        }
      })
    }
  },
  methods: {
    getAlert: function () {
      let body = {
        phases: this.inputValue.phases
      }
      queryAlarm(body).then(res => {
        console.log(res.data)
        this.inputValue.id = res.data.id
        this.inputValue.concentrationCo2Lower = res.data.concentrationCo2Lower
        this.inputValue.concentrationCo2Upper = res.data.concentrationCo2Upper
        this.inputValue.oxygenLower = res.data.oxygenLower
        this.inputValue.oxygenUpper = res.data.oxygenUpper
        this.inputValue.stackMoistureLower = res.data.stackMoistureLower
        this.inputValue.stackMoistureUpper = res.data.stackMoistureUpper
        this.inputValue.stackTempLower = res.data.stackTempLower
        this.inputValue.stackTempUpper = res.data.stackTempUpper
        this.inputValue.tempCoreChipLower = res.data.tempCoreChipLower
        this.inputValue.tempCoreChipUpper = res.data.tempCoreChipUpper
        this.inputValue.wetCoreChipLower = res.data.wetCoreChipLower
        this.inputValue.wetCoreChipUpper = res.data.wetCoreChipUpper
        this.inputValue.warehouseMoistureLower = res.data.warehouseMoistureLower
        this.inputValue.warehouseMoistureUpper = res.data.warehouseMoistureUpper
        this.inputValue.warehouseTempLower = res.data.warehouseTempLower
        this.inputValue.warehouseTempUpper = res.data.warehouseTempUpper
      }).catch(err => {
        console.log(err)
      })
    },
    backPath: function () {
      this.$router.push({
        path: '/warn',
        query: {
          index: '7'
        }
      })
    },
    changeData: function (value) {
      this.inputValue.phases = value
      this.getAlert()
      this.$router.push({
        path: '/warn/setWarn',
        query: {
          index: '7',
          value: value
        }
      })
      this.title.map((data) => {
        data.sign = '0'
        if (data.value === value) {
          data.sign = '1'
        }
      })
    },
    handleData: function () {
      setAlarm(this.inputValue).then(res => {
        console.log(res)
        if (res.code === 200) {
          this.$message({
            message: res.data,
            type: 'warning',
            center: 'true',
            duration: '1000'
          })
        } else {
          this.$message({
            message: res.message,
            type: 'warning',
            center: 'true',
            duration: '1000'
          })
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
  @import "Warn.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/warn/SetWarn.vue